import { LoadingOutlined } from "@ant-design/icons";
import { Space } from "antd";
import cn from "classnames";
import { FC, PropsWithChildren } from "react";

import styles from "./LoadingOverlay.module.scss";

declare type LoadingOverlayPosition =
  | "relative"
  | "absolute"
  | "fixed"
  | "overlay";
type LoadingOverlayProps = {
  loading?: boolean;
  icon?: React.ReactNode;
  label?: React.ReactNode;
  /**
   * relative - take 100% of wrapper
   *
   * absolute - take 100% of page (or wrapper if it contains 'relative')
   *
   * fixed - take 100% of page
   *
   * overlay - take 100% of wrapper and cover children
   */
  position?: LoadingOverlayPosition;
  size?: "small" | "middle" | "large";
  theme?: "light" | "dark";
  animation?: boolean;
  className?: string;
};

export const LoadingOverlay: FC<PropsWithChildren<LoadingOverlayProps>> = ({
  loading = true,
  icon,
  label,
  position,
  size,
  theme,
  animation,
  className,
  children,
}) => {
  return (
    <>
      {loading === true && (
        <div
          className={cn(styles.loadingOverlay, className)}
          data-position={position ?? "relative"}
          data-size={size ?? "middle"}
          data-theme={theme ?? "light"}
          data-animation={animation ?? false}
        >
          <Space size={size} align="center">
            {icon ?? <LoadingOutlined className={styles.icon} />}
            {label}
          </Space>
        </div>
      )}
      {children}
    </>
  );
};
